export default __webpack_public_path__ + "static/media/BeanEmbryo.e2ff54d5.svg";